export enum InvoiceType {
    Receipt = 0,
    Spend = 1,
    Immobilization = 2
}